import { MapComponent } from './map/map.component';

export const components = [MapComponent];
